import { render, staticRenderFns } from "./plaingold.vue?vue&type=template&id=5cc72df1&scoped=true"
import script from "./plaingold.vue?vue&type=script&lang=js"
export * from "./plaingold.vue?vue&type=script&lang=js"
import style0 from "./plaingold.vue?vue&type=style&index=0&id=5cc72df1&prod&lang=scss&scoped=true"
import style1 from "./plaingold.vue?vue&type=style&index=1&id=5cc72df1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc72df1",
  null
  
)

export default component.exports